<template>
  <div class="template">
    <LegiWorkListingParams />
    <LoaderFullPage v-if="store.loading" />
    <LegiWorkListingDatas v-else />
  </div>
</template>

<script setup>
import LegiWorkListingParams from "@follaw-fr/components/legi-work/organisms/LegiWorkListingParams.vue";
import LegiWorkListingDatas from "@follaw-fr/components/legi-work/organisms/LegiWorkListingDatas.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import { useLegiWorkStore } from "@follaw-fr/stores/legi-work.js";
import { useRouter } from "vue-router";

const store = useLegiWorkStore();
const router = useRouter();

store.isFollawedActive =
  router.currentRoute.value.fullPath.includes("follawed");

store.selectedFilters.from = 0;
store.fetchLegiWorkList();
</script>
